import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconDenmarkComponent = ({ ...rest }) => {
  return (
    <SvgIcon {...rest}>
      <svg
        fill="none"
        height="60"
        viewBox="0 0 80 60"
        width="80"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3012_1361)">
          <path d="M0 0H80.0125V60H0V0Z" fill="#C8102E" />
          <path d="M25.7125 0H34.2875V60H25.7125V0Z" fill="white" />
          <path d="M0 25.7125H80.0125V34.2875H0V25.7125Z" fill="white" />
        </g>
        <defs>
          <clipPath id="clip0_3012_1361">
            <rect fill="white" height="60" rx="8" width="80" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

IconDenmarkComponent.displayName = 'IconDenmark';

const IconDenmark = memo(IconDenmarkComponent);

export default IconDenmark;
